/**
 * Toggles a given class on an element. If you supply the `condition` parameter, it will be used
 * to force the class to be either added or removed.
 * @param {Element} el - The element to update
 * @param {String} className - Which class to apply or remove
 * @param {Boolean} [condition] - Set to true or false to force the class on/off, or leave undefined
 */
function toggleClass(el, className, condition) {
  if(el) {
    if (condition === undefined) condition = !el.classList.contains(className);
    (condition ? toggleClassOn : toggleClassOff)(el, className);
  }
}

function toggleClassOn(el, className) {
  !el.classList.contains(className) && el.classList.add(className);
}

function toggleClassOff(el, className) {
  el.classList.contains(className) && el.classList.remove(className);
}

export default toggleClass;
